import React, { useState, useEffect } from 'react';
import CustomTable from '../../../../../customComponents/CustomTable';
import downloadIcon from './../../../../../../Assets/icons/download.svg';
import searchIcon from './../../../../../../Assets/icons/searchicon.svg';
import editIcon from './../../../../../../Assets/icons/Un-Checkbox.svg';
//import './index.scss';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../../../../../services/api/API';
import ROUTES_NAVIGATION from '../../../../../../routes/routes';
import SearchInput from '../../../../../customComponents/CustomSearch/SearchInput';
import Loader from '../../../../../customComponents/CustomLoader';

const LanguageList = () => {
  const [languageData, setLanguageData] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [ totalData, setTotalData ] = useState(0)
  const [totalActive, setTotalActive] = useState(0)
  const [ totalInactive, setTotalInactive ] = useState(0)

  const navigate = useNavigate();
  const token = localStorage.getItem("authToken");

  useEffect(() => {
    fetchLanguageData();
  }, []);
  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fetchLanguageData(newPage);
  };

  const fetchLanguageData = async (page = 0, pageSize = 10) => {
    try {
      setLoading(true)
      const response = await axiosInstance.post('/language/list', {
        orderBy: 'language_id desc',
        page,
        pageSize,
        searchText:searchTerm
      }, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        }
      });

      const formattedData = response?.data?.data?.data?.map((item, index) => ({
        ...item,
        "Sr No.": index + 1  
      }));

      const totalRecordsData = response?.data?.data?.totalRecords
      const totalCount = response?.data?.data?.total
      const totalAct = response?.data?.data?.total_active
      const totalInac = response?.data?.data?.total_inactive

      setTotalData(totalCount)
      setTotalActive(totalAct)
      setTotalInactive(totalInac)

      console.log(totalRecordsData, "RECORDS")
      setTotalRecords(totalRecordsData);
      setLanguageData(formattedData); 
      setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize)); 
    } catch (error) {
      console.error('Error fetching language list:', error);
    }
    finally{
      setLoading(false)
    }
  };

  const LANGUAGE_TABLE_HEADERS = [
    // "Sr No.",
   
    "Language Name",
    "Description",
    "Status",
    "Action"
  ];

  const LANGUAGE_KEY_MAPPING = {
    // "Sr No.": "Sr No.",
    "Language ID": "language_id",
    "Language Name": "language_name",
    "Description": "language_desc",
    "Status": "status",
    "Action": [
      { type: "edit", icon: editIcon, label: "Edit" },
    ]
  };
  const handleEdit = (rowData) => {
    
    navigate(`${ROUTES_NAVIGATION.EDITLANGUAGE}`, { state: { data: rowData } });
     console.log("rowdata", rowData)
  }
  useEffect(() => {
    if (searchTerm === "") {
      fetchLanguageData();
    }
  }, [searchTerm]);

  return (
    <div>
    {loading ? ( 
      <Loader />
    ) : (
    <div>
      <div className='OnboardManagamentContainer row'>
        <div className='OnboardManagamentbuttonContainer col-xl-6 col-lg-12 mt-2 mb-2'>
          <h5>Language Management</h5>
        </div>
        <div className='totalvaluescontainer col-xl-6 col-lg-12 mt-2 mb-2'>
          <div className='totalvalues' style={{borderRight: "1px solid black"}}>
            <h5>{totalData} </h5>
            <h6>All Languages</h6>
          </div>
          <div className='totalvalues' style={{borderRight: "1px solid black"}}>
            <h5>{totalActive} </h5>
            <h6>Active Languages</h6>
          </div>
          <div className='totalvalues'>
            <h5>{totalInactive} </h5>
            <h6>Inactive Languages</h6>
          </div>
          <div>
            <button className='addcustomerbutton' onClick={() => navigate('/admin/manage-user/languages/add-language')}>
              Add Language
            </button>
          </div>
        </div>
      </div>

      <div className='tableWrapper'>
        <div className='admin-list-container'>
          <div className='listsearchContainer'>
            <h5>Languages List</h5>
            <div>
              <SearchInput
                placeholder="Search Language"
                onSearch={fetchLanguageData}
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
              />
            </div>
          </div>
        </div>

        <CustomTable data={languageData} headers={LANGUAGE_TABLE_HEADERS} keyMapping={LANGUAGE_KEY_MAPPING}
        itemsPerPage={10}
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
          onEdit={handleEdit}
          totalRecords={totalRecords} 
          />
      </div>
    </div>
     )}
  </div>
  );
};

export default LanguageList;
